(() => {
  const setUnit = (modal, unit) => {
    modal.dataset.sizeGuideUnit = unit;

    modal.querySelectorAll("[data-size-guide-value]").forEach((value) => {
      const nextValue = unit === "cm" ? value.dataset.cm : value.dataset.inch;
      if (nextValue) value.textContent = nextValue;
    });

    modal.querySelectorAll("[data-size-guide-unit-button]").forEach((button) => {
      const active = button.dataset.sizeGuideUnitButton === unit;
      button.classList.toggle("is-active", active);
      button.setAttribute("aria-pressed", active ? "true" : "false");
    });
  };

  const closeModal = (modal) => {
    if (!modal) return;
    if (typeof modal.close === "function") {
      modal.close();
    } else {
      modal.removeAttribute("open");
    }
  };

  document.addEventListener("click", (event) => {
    const openButton = event.target.closest("[data-np-size-guide-open]");
    if (openButton) {
      event.preventDefault();
      const modal = document.getElementById(openButton.getAttribute("aria-controls"));
      if (!modal) return;
      setUnit(modal, modal.dataset.sizeGuideUnit || "in");
      if (typeof modal.showModal === "function") {
        modal.showModal();
      } else {
        modal.setAttribute("open", "");
      }
      return;
    }

    const unitButton = event.target.closest("[data-size-guide-unit-button]");
    if (unitButton) {
      const modal = unitButton.closest("[data-size-guide-modal]");
      if (modal) setUnit(modal, unitButton.dataset.sizeGuideUnitButton);
      return;
    }

    const closeButton = event.target.closest("[data-size-guide-close]");
    if (closeButton) {
      closeModal(closeButton.closest("[data-size-guide-modal]"));
      return;
    }

    if (event.target.matches("[data-size-guide-modal]")) {
      closeModal(event.target);
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    document.querySelectorAll("[data-size-guide-modal][open]").forEach(closeModal);
  });
})();
